import React, { memo } from "react";

import Icon from "../Icons/Icon";

import "./HawkeyeV2SavedFilters.scss";

function HawkeyeV2SavedFilters(props) {
  const {
    savedFilters,
    selectedFilters,
    editFilter,
    openShowInfo,
    applyFilter,
    deleteSavedFilter,
  } = props;

  const isSelected = (filter) => selectedFilters.some((f) => f.filterID === filter.filterID);

  if (savedFilters.length > 0) {
    return savedFilters.map((filter) => (
      <div
        key={filter.filterName}
        className={`hawkeye-filter-tag ${isSelected(filter) && "is-selected"}`}
      >
        <button
          title={filter.filterName}
          onClick={(e) => applyFilter(filter)}
          className="hawkeye-action hawkeye-filter-tag-name"
        >
          {filter.filterName}
        </button>
        <button
          title="Show filter values"
          onClick={(e) => openShowInfo(filter, true)}
          className="hawkeye-action hawkeye-filter-tag-info"
        >
          <Icon icon="ICON_INFO" className="hawkeye-filter-tag-icon" />
        </button>
        {filter.isEditable && (
          <>
            <button
              title="Edit saved filter"
              onClick={(e) => editFilter(filter)}
              className="hawkeye-action hawkeye-filter-tag-edit"
            >
              <Icon icon="ICON_EDIT" className="hawkeye-filter-tag-icon" />
            </button>
            <button
              title="Delete saved filter"
              onClick={(e) => deleteSavedFilter(filter)}
              className="hawkeye-action hawkeye-filter-tag-remove"
            >
              <Icon icon="ICON_CLOSE" className="hawkeye-filter-tag-icon" />
            </button>
          </>
        )}
      </div>
    ));
  } else {
    return null;
  }
}

export default memo(HawkeyeV2SavedFilters);
